/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as UserRoleService} from "../../../Services/UserRoleService";
import React from "react";
import {ServiceDrivenDropDownFieldEditor} from "./ServiceDrivenDropDownFieldEditor";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";

export const UserRolePicker = ServiceDrivenDropDownFieldEditor(UserRoleService);

export const UserRoleFieldEditor = (props) => {
	
	usePrimeCache([UserRoleService]);
	
	return <UserRolePicker
		// public user role is not selectable
		filter={ (values, selectedItem) => 
			values.filter((userRole) => (userRole?.title !== 'Public'))
		}
		{...props}
	/>
	
}
